// Crumble - An Unstoppable Word Game (Enhanced Version)


import React, { useState, useEffect, useCallback, useMemo } from 'react';
import './VanishingPoint.css'; // External CSS for styling and animations
//import WORDS from './wordBank.js';
import PocketBase from 'pocketbase';
import { QuestionMarkCircleIcon } from '@heroicons/react/24/solid';
import { LightBulbIcon } from '@heroicons/react/24/solid';
import { Bars3Icon } from '@heroicons/react/24/solid';
import { CalendarDaysIcon } from '@heroicons/react/24/solid';

import ufLogo from './UF_logo.png';
import bannerLogo from './crumbleVault_animations/crumbleVault.gif';

import stage0 from './figureAnim_imgs2/Idle/stage0.gif';
import stage1 from './figureAnim_imgs2/Idle/stage1.gif';
import stage2 from './figureAnim_imgs2/Idle/stage2.gif';
import stage3 from './figureAnim_imgs2/Idle/stage3.gif';
import stage4 from './figureAnim_imgs2/Idle/stage4.gif';
import stage5 from './figureAnim_imgs2/Idle/stage5.gif';
import stage6 from './figureAnim_imgs2/Idle/stage6.gif';
import stage7 from './figureAnim_imgs2/Idle/stage7.gif';

import loss1 from './figureAnim_imgs2/Losses/loss0.gif';
import loss2 from './figureAnim_imgs2/Losses/loss1.gif';
import loss3 from './figureAnim_imgs2/Losses/loss2.gif';
import loss4 from './figureAnim_imgs2/Losses/loss3.gif';
import loss5 from './figureAnim_imgs2/Losses/loss4.gif';
import loss6 from './figureAnim_imgs2/Losses/loss5.gif';
import loss7 from './figureAnim_imgs2/Losses/loss6.gif';

import win1 from './figureAnim_imgs2/Wins/win0.gif';
import win2 from './figureAnim_imgs2/Wins/win1.gif';
import win3 from './figureAnim_imgs2/Wins/win2.gif';
import win4 from './figureAnim_imgs2/Wins/win3.gif';
import win5 from './figureAnim_imgs2/Wins/win4.gif';
import win6 from './figureAnim_imgs2/Wins/win5.gif';
import win7 from './figureAnim_imgs2/Wins/win6.gif';
import winLoop from './figureAnim_imgs2/Wins/win.gif';


import CrumblePlus from './crumblePlus';

const BODY_PARTS = ['Head', 'Right Arm', 'Left Arm', 'Right Leg', 'Left Leg', 'Torso', 'Heart'];
const pb = new PocketBase('https://api.vanishing.play-it.me/');

const Crumble = () => {
const [showCrumblePlus, setShowCrumblePlus] = useState(false);
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [darkMode, setDarkMode] = useState(() => {
      const saved = localStorage.getItem('vpDarkMode');
      return saved ? JSON.parse(saved) : false;
    });
  const [showPopup, setShowPopup] = useState(false);
  const [inputQueue, setInputQueue] = useState([]); // Queue for stacked guesses
  const [showInfoPopup, setShowInfoPopup] = useState(false);
  const [showCalendarPopup, setShowCalendarPopup] = useState(false);

const [guesses, setGuesses] = useState(() => {
  const savedWord = localStorage.getItem('vpWord');
  const savedGuesses = localStorage.getItem('vpGuesses');
  const currentWord = localStorage.getItem('vpCurrentWord');
  if (savedWord && savedGuesses && savedWord === currentWord) {
    const parsed = JSON.parse(savedGuesses);
    return Array.isArray(parsed) ? parsed : [];
  }
  return [];
});
const [wrongGuesses, setWrongGuesses] = useState(() => {
  const savedWord = localStorage.getItem('vpWord');
  const savedWrongGuesses = localStorage.getItem('vpWrongGuesses');
  const currentWord = localStorage.getItem('vpCurrentWord');
  if (savedWord && savedWrongGuesses && savedWord === currentWord) {
    return parseInt(savedWrongGuesses);
  }
  return 0;
});
const [gameOver, setGameOver] = useState(() => {
  const savedWord = localStorage.getItem('vpWord');
  const savedGameOver = localStorage.getItem('vpGameOver');
  const currentWord = localStorage.getItem('vpCurrentWord');
  if (savedWord && savedGameOver && savedWord === currentWord) {
    return JSON.parse(savedGameOver);
  }
  return false;
});
const [victory, setVictory] = useState(() => {
  const savedWord = localStorage.getItem('vpWord');
  const savedVictory = localStorage.getItem('vpVictory');
  const currentWord = localStorage.getItem('vpCurrentWord');
  if (savedWord && savedVictory && savedWord === currentWord) {
    return JSON.parse(savedVictory);
  }
  return false;
});
const [showClue, setShowClue] = useState(() => {
  const savedWord = localStorage.getItem('vpWord');
  const savedShowClue = localStorage.getItem('vpShowClue');
  const currentWord = localStorage.getItem('vpCurrentWord');
  if (savedWord && savedShowClue && savedWord === currentWord) {
    return JSON.parse(savedShowClue);
  }
  return false;
});
const [streak, setStreak] = useState(() => parseInt(localStorage.getItem('vpStreak')) || 0);
const [showGif, setShowGif] = useState(false); // State to track if the GIF is being shown
const stages = useMemo(() => [
    stage0, stage1, stage2, stage3, stage4, stage5, stage6, stage7
  ], []);
  const losses = useMemo(() => [
    loss1, loss2, loss3, loss4, loss5, loss6, loss7
  ], []);
  const wins = useMemo(() => [
    win1, win2, win3, win4, win5, win6, win7
  ], []);
  const [showWinLoop, setShowWinLoop] = useState(false);
  const [disableInput, setDisableInput] = useState(false); // State to disable input during transitions

  const [WORDS, setWORDS] = useState([{word: 'CRUMBLE', clue: "You're playing it!"}]);
  const [current, setCurrent] = useState(null);

// wordIndex and wordDate are now handled below with useMemo and calendarDate

  const [calendarDate, setCalendarDate] = useState(new Date().toISOString().slice(0, 10));

  const handleCalendarSelect = (dateStr) => {
    setCalendarDate(dateStr);
    setShowCalendarPopup(false);
    // Reset game state for new date
    setGuesses([]);
    setWrongGuesses(0); // Resets BODY_PARTS left to 7
    setGameOver(false);
    setVictory(false);
    setShowClue(false);
    setShowWinLoop(false);
    setShowGif(false);
    setDisableInput(false);
  };

// Use calendarDate for selected date, fallback to today
const selectedDateObj = useMemo(() => {
  return calendarDate ? new Date(calendarDate) : new Date();
}, [calendarDate]);

const wordDate = useMemo(() =>
  selectedDateObj.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  }), [selectedDateObj]
);

const startDate = useMemo(() => new Date(2023, 0, 1), []);
const wordIndex = useMemo(() => {
  if (!WORDS || WORDS.length === 0) return null;
  // Calculate days since startDate for the selected date
  const daysSinceStart = Math.floor((selectedDateObj - startDate) / (1000 * 60 * 60 * 24));
  return ((daysSinceStart % WORDS.length) + WORDS.length) % WORDS.length; // always positive
}, [WORDS, selectedDateObj, startDate]);

const getWordOfTheDay = useCallback(() => {
  if (!WORDS || WORDS.length === 0) return null;
  return WORDS[wordIndex];
}, [WORDS, wordIndex]);

  useEffect(() => {
    const fetchWord = async () => {
        try {
        const records = await pb.collection('words').getFullList({
          fields: 'word,clue',
        });
        setWORDS(records);
      } catch (err) {
        // Optionally handle error
      }
    };
    fetchWord();
  }, []);

  // When WORDS updates, set current
  useEffect(() => {
    if (WORDS && WORDS.length > 0) {
      setCurrent(getWordOfTheDay());
    }
  }, [WORDS, getWordOfTheDay, calendarDate]);

  useEffect(() => {
    setShowPopup(true);
  }, []);

  useEffect(() => {
    localStorage.setItem('vpShowClue-<word>', JSON.stringify(showClue));
  }, [showClue]);
  
  useEffect(() => {
    localStorage.setItem('vpGuesses-<word>', JSON.stringify(guesses));
  }, [guesses]);
  useEffect(() => {
  if (darkMode) {
    document.body.classList.add('dark-mode');
    document.documentElement.classList.add('dark-mode');
  } else {
    document.body.classList.remove('dark-mode');
    document.documentElement.classList.remove('dark-mode');
  }
}, [darkMode]);
  useEffect(() => {
    localStorage.setItem('vpWrongGuesses-<word>', wrongGuesses.toString());
  }, [wrongGuesses]);
  useEffect(() => {
    localStorage.setItem('vpGameOver-<word>', JSON.stringify(gameOver));
  }, [gameOver]);
  useEffect(() => {
    localStorage.setItem('vpVictory-<word>', JSON.stringify(victory));
  }, [victory]);
  
// When WORDS updates, set current
useEffect(() => {
  if (WORDS && WORDS.length > 0) {
    setCurrent(getWordOfTheDay());
  }
}, [WORDS, getWordOfTheDay]);

useEffect(() => {
  if (!current || !current.word) return;

  // Get today's date as a string (e.g., "2025-06-25")
  const todayStr = new Date().toISOString().slice(0, 10);
  const storedDate = localStorage.getItem('vpLastPlayedDate');

  if (storedDate !== todayStr) {
    // New day, reset everything
    localStorage.setItem('vpLastPlayedDate', todayStr);
    localStorage.setItem('vpCurrentWord', current.word);
    localStorage.removeItem('vpGuesses-<word>');
    localStorage.removeItem('vpWrongGuesses-<word>');
    localStorage.removeItem('vpGameOver-<word>');
    localStorage.removeItem('vpVictory-<word>');
    localStorage.removeItem('vpShowClue-<word>');
    setGuesses([]);
    setWrongGuesses(0);
    setGameOver(false);
    setVictory(false);
    setShowClue(false);
  }
}, [current]);

<link href="https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@500&display=swap" rel="stylesheet"></link>


const getImageForStage = () => {
  if (showGif) {
    if (victory) {
      // Show the win GIF for the current wrongGuesses count
      return `${wins[wrongGuesses]}?t=${new Date().getTime()}`;
    } else {
      // Show the loss GIF for the current wrongGuesses count
      return `${losses[wrongGuesses]}?t=${new Date().getTime()}`;
    }
  }
    if (victory && showWinLoop) {
      // After the win GIF, show the looping win GIF (force restart with cache buster)
      return `${winLoop}?t=${new Date().getTime()}`;
    }
  return stages[wrongGuesses]; // Otherwise, show the current stage image
};

const handleGuess = useCallback((letter) => {
  if (!current || guesses.includes(letter) || gameOver) return;
  const newGuesses = [...guesses, letter];
  setGuesses(newGuesses);
  if (disableInput) {
    setInputQueue((q) => [...q, letter]);
    return;
  }

  if (!current.word.toUpperCase().includes(letter)) {
    const newWrong = wrongGuesses + 1;

    if (newWrong <= BODY_PARTS.length) {
      setDisableInput(true);
      setShowGif(true);

      // Preload the next stage image
      const nextStageImg = new Image();
      nextStageImg.src = stages[newWrong];

      // Adjust this duration to match your actual GIF length (in ms)
      const gifDuration = 4000; // e.g., 1.5 seconds

      setTimeout(() => {
        setShowGif(false);
        setWrongGuesses(newWrong); // Only increment after GIF
        setDisableInput(false);
        if (inputQueue.length > 0) {
          const [next, ...rest] = inputQueue;
          setInputQueue(rest);
          setTimeout(() => handleGuess(next), 0); // Process next guess
        }
        if (newWrong === BODY_PARTS.length) {
          setGameOver(true);
          localStorage.setItem('vpStreak', '0');
        }
      }, gifDuration);
    }
  } else {
    const completed = current
      ? current.word
          .toUpperCase()
          .split('')
          .every((l) => newGuesses.includes(l))
      : false;
    if (completed) {
      setDisableInput(true);
      setShowGif(true);
      setVictory(true);

      // Preload the win loop GIF before the transition
      const winLoopImg = new window.Image();
      winLoopImg.src = winLoop;

      setTimeout(() => {
        setShowGif(false);
        setShowWinLoop(true);
        setGameOver(true);
        setDisableInput(false);
        
        const newStreak = streak + 1;
        setStreak(newStreak);
        localStorage.setItem('vpStreak', newStreak.toString());
      }, 4000); // Duration of your win GIF
    }
  }
}, [guesses, gameOver, current, wrongGuesses, streak, stages, disableInput, inputQueue]);

useEffect(() => {
  if (gameOver || disableInput) return;

  const handleKeyDown = (event) => {
    if (!event.key) return; // Guard against undefined
    const key = event.key.toUpperCase();
    if (/^[A-Z]$/.test(key)) {
      handleGuess(key);
    }
  };
  window.addEventListener('keydown', handleKeyDown);
  return () => window.removeEventListener('keydown', handleKeyDown);
}, [guesses, gameOver, disableInput, handleGuess]);


const renderWord = () => {
  if (!current || !current.word) return null;
  return current.word.split('').map((letter, i) => {
    const upperLetter = letter.toUpperCase();
    if (gameOver && !victory && !guesses.includes(upperLetter)) {
      // Game lost, letter was missing
      return (
        <span key={i} className="vp-letter vp-missing-letter">
          {upperLetter}
        </span>
      );
    }
    return (
      <span key={i} className="vp-letter">
        {guesses.includes(upperLetter) || (gameOver && victory) ? upperLetter : '_'}
      </span>
    );
  });
};

  const renderAlphabet = () => {
    const rows = [
      'QWERTYUIOP',
      'ASDFGHJKL',
      'ZXCVBNM',
    ]; // Split the alphabet into rows
  
    return (
      <div className="vp-alphabet">
        {rows.map((row, rowIndex) => (
          <div key={rowIndex} className="vp-alphabet-row">
            {row.split('').map((letter) => (
              <button
                key={letter}
                disabled={guesses.includes(letter) || disableInput} // Disable buttons if input is disabled
                onClick={() => handleGuess(letter)}
                className="vp-letter-button"
              >
                {letter}
              </button>
            ))}
          </div>
        ))}
      </div>
    );
  };
const [copied, setCopied] = useState(false); // Add this near your other useState hooks

const shareResult = () => {
  let phaseMessage = '';
  if (wrongGuesses === 0) {
    phaseMessage = '🟩🟩🟩🟩🟩🟩🟩';
  } else if (wrongGuesses === 1) {
    phaseMessage = `❌🟩🟩🟩🟩🟩🟩`;
  } else if (wrongGuesses === 2) {
    phaseMessage = `❌❌🟩🟩🟩🟩🟩`;
  } else if (wrongGuesses === 3) {
    phaseMessage = `❌❌❌🟩🟩🟩🟩`;
  } else if (wrongGuesses === 4) {
    phaseMessage = `❌❌❌❌🟩🟩🟩`;
  } else if (wrongGuesses === 5) {
    phaseMessage = `❌❌❌❌❌🟩🟩`;
  } else if (wrongGuesses === 6) {
    phaseMessage = `❌❌❌❌❌❌🟩`;
  } else {
    phaseMessage = '❌❌❌❌❌❌❌';
  }

  const result = victory
    ? `🫵I survived Crumble! ${phaseMessage}`
    : `🫵I crumbled today. Will you?`;

  const text = `${result} Play daily at https://crumble.unstoppableforce.co.nz/`;
  if (navigator.share) {
    navigator.share({ title: 'Crumble', text, url: window.location.href });
  } else {
    navigator.clipboard.writeText(text);
    setCopied(true); // Show custom copied message
    setTimeout(() => setCopied(false), 1000); // Hide after 1 second
  }
};

  return (
    <div className={`vp-container${darkMode ? ' dark' : ''}`}>
      {showCrumblePlus ? (
        <CrumblePlus />
      ) : (
        <>
          {showPopup && (
            <div className="vp-popup-overlay">
              <div className="vp-popup">
                <h2>Welcome to Crumble Vault!</h2>
                  <p>Delve into the Vault to play past words!</p>
                  <p>It's the same fun game but you aren't stuck with one word a day anymore!</p>
                  <p>Can you win every day in the Vault or are you going to Crumble?"</p>
                <button onClick={() => setShowPopup(false)} className="vp-play-button">Play!</button>
                </div>
              </div>
          )}
      
        {showInfoPopup && (
      <div className="vp-popup-overlay">
        <div className="vp-popup">
          <h2>About Unstoppable Force, The Makers of Crumble!</h2>
          <p>Unstoppable Force is a bold leadership and personal growth movement built to help people like you level up in real life—not just in-game. </p>
          <p>We turn mental resilience, team connection, and self-leadership into your ultimate power-ups. </p>
          <p>If you’re ready to live beyond your limits, you’re in the right place.</p>
          <p> Visit <a href="https://unstoppableforce.co.nz">our website</a> for more information!</p>
          <button onClick={() => setShowInfoPopup(false)} className="vp-play-button">Back to the game!</button>
        </div>
      </div>
    )}

    {showCalendarPopup && (
      <div className="vp-popup-overlay">
        <div className="vp-popup">
          <h2>Select a Date to Play a Past Word</h2>
          <input
            type="date"
            value={calendarDate}
            onChange={e => setCalendarDate(e.target.value)}
            className="vp-calendar-input"
            min="2023-01-01" // Set your earliest word date here
            max={new Date().toISOString().slice(0, 10)}
          />
          <div style={{ marginTop: '1em' }}>
            <button
              onClick={() => {
                setShowCalendarPopup(false);
                handleCalendarSelect(calendarDate);
              }}
              className="vp-play-button"
            >
              Play Word
            </button>
            <button
              onClick={() => setShowCalendarPopup(false)}
              className="vp-play-button"
              style={{ marginLeft: '1em' }}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    )}

    <div className="vp-toolbar">
        <div className="vp-date">
        <h2>{wordDate}</h2>
        <h2>Word #{wordIndex}</h2>
        </div>
      <div className="cv-title">
          <img src={bannerLogo} alt="bannerLogo" />
      </div>
      
      <button
        className="vp-toolbar-hamburger"
        onClick={() => setShowMobileMenu((open) => !open)}
        aria-label="Menu" >
        <Bars3Icon style={{ width: 32, height: 32, verticalAlign: 'middle'}} />
      </button>
      <div className="vp-toolbar-buttons">
        
        <button
          onClick={() => setShowCalendarPopup(true)}
          className="vp-toolbar-button"
          title="Pick a Past Day" >
        <CalendarDaysIcon style={{ width: 32, height: 32, verticalAlign: 'left'}} />
        </button>
       
        <button
          onClick={() => setShowInfoPopup(true)}
          className="vp-toolbar-button"
          title="About Us" >
          <img src={ufLogo} alt="UF Logo" style={{ width: 32, height: 32, verticalAlign: 'middle', borderRadius: '6px' }} />
        </button>
        
        <button
          onClick={() => {
            setDarkMode((prev) => {
              localStorage.setItem('vpDarkMode', JSON.stringify(!prev));
              return !prev;
            });
          }}
          className="vp-toolbar-button"
          title="Color Scheme" >
          <LightBulbIcon style={{ width: 32, height: 32, verticalAlign: 'middle'}} />
        </button>
        
        <button
          onClick={() => setShowPopup(true)}
          className="vp-toolbar-button"
          title="How to Play" >
          <QuestionMarkCircleIcon style={{ width: 32, height: 32, verticalAlign: 'middle'}} />
        </button>
      
      </div>
      {/* Mobile dropdown */}
      {showMobileMenu && (
        <div className="vp-mobile-menu">
          <button
            onClick={() => { setShowInfoPopup(true); setShowMobileMenu(false); }}
            className="vp-toolbar-button"
            title="Info"
          >
            <img src={ufLogo} alt="UF Logo" style={{ width: 32, height: 32, verticalAlign: 'middle', borderRadius: '6px' }} />
            Info
          </button>
          <button
            onClick={() => {
              setDarkMode((prev) => {
                localStorage.setItem('vpDarkMode', JSON.stringify(!prev));
                return !prev;
              });
              setShowMobileMenu(false);
            }}
            className="vp-toolbar-button"
            title="Light/Dark Mode"
          >
            <LightBulbIcon style={{ width: 32, height: 32, verticalAlign: 'middle'}} />
            {darkMode ? 'Light' : 'Dark'}
          </button>
          <button
            onClick={() => { setShowPopup(true); setShowMobileMenu(false); }}
            className="vp-toolbar-button"
            title="How to Play"
          >
            <QuestionMarkCircleIcon style={{ width: 32, height: 32, verticalAlign: 'middle'}} />
            How to Play
          </button>
        </div>
      )}
    </div>
          {current && (
<>

                  <button
            className="vp-play-button"
            style={{ marginTop: -100 }}
            onClick={() => setShowCrumblePlus(true)}
          >
            Back to Crumble+
          </button>

  {!gameOver && (
    <>

      {!showClue ? (
        <button
          onClick={() => {
            setShowClue(true);
            setShowGif(true);
            setDisableInput(true);
            setTimeout(() => {
              setShowGif(false);
              setWrongGuesses((prev) => Math.min(prev + 1, BODY_PARTS.length));
              setDisableInput(false);
            }, 2500);
          }}
          className="vp-hint-button"
        >
          Show Hint
        </button>
      ) : (
        <p className="vp-clue"><strong>Clue:</strong> {current.clue}</p>
      )}
    </>
  )}
  <div className="vp-word">{renderWord()}</div>
  <div className="vp-body">
    <div className="vp-image-container">
      <img src={getImageForStage()} alt={`Stage ${wrongGuesses}`} className="vp-stage-image" />
    </div>
  </div>
  {gameOver && (
    <div className="vp-end">
      {victory ? '🎉 You held the line! You are Unstoppable! ' : '💀 You crumbled, better luck tomorrow. '}
      <button onClick={shareResult} className="vp-share-button">Share</button>
    </div>
  )}
  {copied && (
  <div className="vp-copied-message">Copied!</div>
)}

  <p className="vp-info">Body Parts Left: {BODY_PARTS.length - wrongGuesses}</p>
  <p className="vp-streak">Your Streak: {streak}</p>
  {!gameOver && <div className="vp-alphabet">{renderAlphabet()}</div>}
</>
      )}
        </>
      )}
    </div>
  )
}

export default Crumble;